import { HTMLAttributes, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import {
  RiChat3Line as ChatBubbleOutline,
  RiEmotionLine as InsertEmoticonIcon,
} from '@remixicon/react';
import classNames from 'classnames';

import ReactionButton from './ReactionButton';
import { useActivityFeedItemContext } from './context';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  });

export interface FooterProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes'>,
    WithStyles<typeof styles> {}

const Footer = forwardRef<HTMLDivElement, FooterProps>((props, ref) => {
  const { className, classes, ...rest } = props;
  const { showComments, setShowComments, reactions } =
    useActivityFeedItemContext();

  const commentsCount = reactions.commentCount ?? 0;

  return (
    <div ref={ref} className={classNames(classes.root, className)} {...rest}>
      <ReactionButton
        iconComponent={ChatBubbleOutline}
        count={commentsCount > 0 ? commentsCount : undefined}
        onClick={() => setShowComments(!showComments)}
      />
      <ReactionButton iconComponent={InsertEmoticonIcon} />
    </div>
  );
});

Footer.displayName = 'ActivityFeedItem.Footer';

export default withStyles(styles)(Footer);
